import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "task-tags-select" }
const _hoisted_2 = {
  key: 0,
  class: "task-tags-select__tag-separator"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  class: "task-tags-select__tag-button-icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM9.53033 8.46967C9.23744 8.17678 8.76256 8.17678 8.46967 8.46967C8.17678 8.76256 8.17678 9.23744 8.46967 9.53033L10.9393 12L8.46967 14.4697C8.17678 14.7626 8.17678 15.2374 8.46967 15.5303C8.76256 15.8232 9.23744 15.8232 9.53033 15.5303L12 13.0607L14.4697 15.5303C14.7626 15.8232 15.2374 15.8232 15.5303 15.5303C15.8232 15.2374 15.8232 14.7626 15.5303 14.4697L13.0607 12L15.5303 9.53033C15.8232 9.23744 15.8232 8.76256 15.5303 8.46967C15.2374 8.17678 14.7626 8.17678 14.4697 8.46967L12 10.9393L9.53033 8.46967Z"
  })
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "task-tags-select__button"
}
const _hoisted_7 = { class: "task-tags-select__selected-content" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "task-tags-select__tag-separator" }, null, -1)
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  class: "task-tags-select__tag-button-icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM9.53033 8.46967C9.23744 8.17678 8.76256 8.17678 8.46967 8.46967C8.17678 8.76256 8.17678 9.23744 8.46967 9.53033L10.9393 12L8.46967 14.4697C8.17678 14.7626 8.17678 15.2374 8.46967 15.5303C8.76256 15.8232 9.23744 15.8232 9.53033 15.5303L12 13.0607L14.4697 15.5303C14.7626 15.8232 15.2374 15.8232 15.5303 15.5303C15.8232 15.2374 15.8232 14.7626 15.5303 14.4697L13.0607 12L15.5303 9.53033C15.8232 9.23744 15.8232 8.76256 15.5303 8.46967C15.2374 8.17678 14.7626 8.17678 14.4697 8.46967L12 10.9393L9.53033 8.46967Z"
  })
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "task-tags-select__missing-tags"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "task-tags-select__missing-tags-text" }, " В проекте нет тегов для добавления ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "task-tags-select__button-plus-hint" }, "Перейти к созданию тегов", -1)
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "task-tags-select__option__description" }

import { computed, nextTick, PropType, ref } from "vue";
import { TagModel } from "../../models";
import { TagMultiselectOptionModel } from "./models";
import {
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
  PopoverPositionEnum,
  PopoverPositionType,
  TirPmIconView,
  TirPmPopover,
  PopoverColorEnum,
  TirPmMultiselect,
  TirPmTooltipElement,
} from "tir-components";
import { PlusIcon, TagIcon, InformationCircleIcon } from "tir-style-system/icons/outline";
import { CurrentUser, UserRoleEnum } from "tir-pm-user-core";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'task-tags-select',
  props: {
  /**Возможность редактировать */
  editing: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
  /**Выбранные теги */
  modelValue: {
    type: Array as PropType<Array<number>>,
    default: [],
  },
  /**Список тегов для выбора */
  options: {
    type: Array as PropType<Array<TagModel>>,
    default: [],
  },
  /**Является ли юзер админом НС */
  isNamespaceAdmin: {
    type: Boolean,
  },
  /**Является ли юзер админом проекта */
  isProjectAdmin: {
    type: Boolean,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;





const router = useRouter();

/**Ссылка на компонент Multiselect */
const $multiselect = ref<{ updatePopover: () => void } | undefined>(); // InstanceType не работает с дженерик компонентами

/**Опции мультиселекта */
const multiselectOptions = computed(() =>
  props.options.map(
    (option) =>
      new TagMultiselectOptionModel({
        Id: option.Id,
        Name: option.Name,
        Color: option.Color,
        Description: option.Description,
      }),
  ),
);

/**Овнер */
const isOwner = CurrentUser.Roles.includes(UserRoleEnum.Owner);

const isOpenMultiselect = ref();

/**Является ли текующий пользователь обычным юзером  */
const isRegularUser = CurrentUser.Roles.includes(1);

const checkOpenMultiselect = () => {
  isOpenMultiselect.value = !isOpenMultiselect.value;

  // event.stopPropagation();
  document.addEventListener("click", () => {
    isOpenMultiselect.value = false;
  });
};

/**Выбранные опции */
const selectedOptions = computed(() =>
  multiselectOptions.value.filter((option) => props.modelValue.includes(option.Id)),
);

const popoverPosition = computed<any>(() => {
  if (!props.modelValue.length)
    return {
      top: "0.25rem + $el:height",
      left: "0rem",
    };
  return PopoverPositionEnum.Bottom;
});

/**Выбор опции */
const selectOption = async (optionId: number) => {
  emit("update:modelValue", [...props.modelValue, optionId]);
  await nextTick();
  $multiselect.value?.updatePopover();
};

/**Перенапровление на страницу создания тегов */
const redirectToTags = () => {
  const route = router.resolve({
    name: "project-tags",
  });
  window.open(route.href, "_blank");
};

/**Убрать выбор опции */
const unSelectOption = async (optionId: number) => {
  emit(
    "update:modelValue",
    props.modelValue.filter((_optionId) => optionId !== _optionId),
  );
  await nextTick();
  $multiselect.value?.updatePopover();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedOptions.value, (option) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "task-tags-select__tag",
        key: option.Id,
        style: _normalizeStyle({ borderColor: option.Color })
      }, [
        _createElementVNode("span", {
          class: "task-tags-select__tag-name",
          style: _normalizeStyle({ color: option.Color })
        }, _toDisplayString(option.Name), 5),
        (__props.editing)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2))
          : _createCommentVNode("", true),
        (__props.editing)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "task-tags-select__tag-button",
              onClick: _withModifiers(($event: any) => (unSelectOption(option.Id)), ["stop"])
            }, _hoisted_5, 8, _hoisted_3))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "task-tags-select__tag-bg",
          style: _normalizeStyle({ backgroundColor: option.Color })
        }, null, 4)
      ], 4))
    }), 128)),
    (__props.editing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_unref(TirPmMultiselect), {
            popoverClasses: "task-tags-select__multiselect",
            ref_key: "$multiselect",
            ref: $multiselect,
            searchInputLabel: "Поиск тегов",
            options: multiselectOptions.value,
            "selected-options": selectedOptions.value,
            "popover-position": popoverPosition.value,
            "popover-width": "32.5rem",
            "is-disabled-popover": !multiselectOptions.value.length && _unref(isRegularUser),
            onOnOpen: checkOpenMultiselect
          }, {
            target: _withCtx(() => [
              _createElementVNode("div", null, [
                (!__props.modelValue.length)
                  ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                      key: 0,
                      variant: _unref(TirPmButtonVariantEnum).SecondaryState,
                      isDisabled: !multiselectOptions.value.length && _unref(isRegularUser),
                      size: _unref(TirPmButtonSizeEnum).Small,
                      isPressed: isOpenMultiselect.value
                    }, {
                      leftSlot: _withCtx(() => [
                        _createVNode(_unref(PlusIcon))
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" Добавить тег ")
                      ]),
                      _: 1
                    }, 8, ["variant", "isDisabled", "size", "isPressed"]))
                  : (_openBlock(), _createBlock(_unref(TirPmButton), {
                      key: 1,
                      variant: _unref(TirPmButtonVariantEnum).LinkState,
                      size: _unref(TirPmButtonSizeEnum).Small,
                      isPressed: isOpenMultiselect.value
                    }, {
                      leftSlot: _withCtx(() => [
                        _createVNode(_unref(PlusIcon), { style: {"color":"var(--text-primary, #272d37)"} })
                      ]),
                      _: 1
                    }, 8, ["variant", "size", "isPressed"]))
              ])
            ]),
            selectedContent: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedOptions.value, (option) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "task-tags-select__tag",
                    key: option.Id,
                    style: _normalizeStyle({ borderColor: option.Color })
                  }, [
                    _createElementVNode("span", {
                      class: "task-tags-select__tag-name",
                      style: _normalizeStyle({ color: option.Color })
                    }, _toDisplayString(option.Name), 5),
                    _hoisted_8,
                    _createElementVNode("button", {
                      class: "task-tags-select__tag-button",
                      onClick: ($event: any) => (unSelectOption(option.Id))
                    }, _hoisted_11, 8, _hoisted_9),
                    _createElementVNode("div", {
                      class: "task-tags-select__tag-bg",
                      style: _normalizeStyle({ backgroundColor: option.Color })
                    }, null, 4)
                  ], 4))
                }), 128))
              ]),
              (!multiselectOptions.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_unref(TirPmIconView), {
                      "is-bordered": false,
                      size: 48,
                      class: "task-tags-select__tag-icon-block"
                    }, {
                      mainSlot: _withCtx(() => [
                        _createVNode(_unref(TagIcon), { class: "task-tags-select__tag-icon" })
                      ]),
                      _: 1
                    }),
                    _hoisted_13,
                    _createVNode(_unref(TirPmButton), {
                      variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                      size: _unref(TirPmButtonSizeEnum).Small,
                      onClick: redirectToTags
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Перейти к созданию тегов ")
                      ]),
                      _: 1
                    }, 8, ["variant", "size"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            rightInputAddons: _withCtx(() => [
              (_unref(isOwner) || __props.isNamespaceAdmin || __props.isProjectAdmin)
                ? (_openBlock(), _createBlock(_unref(TirPmTooltipElement), {
                    key: 0,
                    width: "max-content"
                  }, {
                    content: _withCtx(() => [
                      _hoisted_14
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(TirPmButton), {
                        class: "task-tags-select__button-plus",
                        variant: _unref(TirPmButtonVariantEnum).SecondaryState,
                        size: _unref(TirPmButtonSizeEnum).Regular,
                        onClick: redirectToTags
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(PlusIcon), { class: "task-tags-select__plus-icon" })
                        ]),
                        _: 1
                      }, 8, ["variant", "size"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            optionList: _withCtx(({ option }) => [
              _createElementVNode("div", {
                class: "task-tags-select__option",
                onClick: ($event: any) => (selectOption(option.Id))
              }, [
                _createElementVNode("div", {
                  class: "task-tags-select__tag",
                  style: _normalizeStyle({ borderColor: option.Color })
                }, [
                  _createElementVNode("span", {
                    class: "task-tags-select__tag-name",
                    style: _normalizeStyle({ color: option.Color })
                  }, _toDisplayString(option.Name), 5),
                  _createElementVNode("div", {
                    class: "task-tags-select__tag-bg",
                    style: _normalizeStyle({ backgroundColor: option.Color })
                  }, null, 4)
                ], 4),
                (option.Description)
                  ? (_openBlock(), _createBlock(_unref(TirPmTooltipElement), {
                      key: 0,
                      width: "15rem"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(option.Description), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(InformationCircleIcon), { class: "task-tags-select__option__icon" })
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_15)
            ]),
            _: 1
          }, 8, ["options", "selected-options", "popover-position", "is-disabled-popover"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})